import { render, staticRenderFns } from "./RedemptionModal.vue?vue&type=template&id=ead7ad50&scoped=true"
import script from "./RedemptionModal.vue?vue&type=script&lang=js"
export * from "./RedemptionModal.vue?vue&type=script&lang=js"
import style0 from "./RedemptionModal.vue?vue&type=style&index=0&id=ead7ad50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead7ad50",
  null
  
)

export default component.exports